<div [ngSwitch]="errorType">
	<div *ngSwitchCase="MODAL_ERROR_TYPE" class="text-center">
		<div *ngIf="!hideErrorIcon" class="flex justify-center">
			<svg fill="none" height="68" viewBox="0 0 68 68" width="68" xmlns="http://www.w3.org/2000/svg">
				<circle cx="34" cy="34" fill="#E94444" fill-opacity="0.1" r="34"/>
				<path
					d="M34 56.5C21.5736 56.5 11.5 46.4264 11.5 34C11.5 21.5736 21.5736 11.5 34 11.5C46.4264 11.5 56.5 21.5736 56.5 34C56.4864 46.4208 46.4208 56.4864 34 56.5ZM31.75 40.75V45.25H36.25V40.75H31.75ZM31.75 22.75V36.25H36.25V22.75H31.75Z"
					fill="#E94444"/>
			</svg>
		</div>
		<div class="m-t-16">
			<div class="success-title">
				{{title|titlecase}}
			</div>
		</div>
		<div class="m-t-6">
			<div class="success-des">
				{{description}}
			</div>
		</div>
		<div *ngIf="!isTableUse" class="m-t-16">
			<div class="success-divider {{useFullButton?'success-divider-adjustment':''}}">
			</div>
		</div>
		<div *ngIf="!useFullButton" class="m-t-16">
			<div nz-row nzAlign="middle" nzJustify="space-between">
				<div></div>
				<div nz-row nzAlign="middle">
					<div>
						<div (click)="cancelModal()" *ngIf="canShowCancelButton" class="back-btn">
							Dismiss
						</div>
					</div>
					<div>
						<div class="{{canShowCancelButton?'m-l-32':''}}">
							<button (click)="canShowCancelButton? continue() : cancelModal()"
									class="btn btn-primary button-size-157" nz-button>
								{{buttonText ? buttonText : 'Close'}}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="useFullButton" class="m-t-16">
			<div>
				<button (click)="cancelModal()" class="btn btn-primary full-btn" nz-button>{{buttonText}}</button>
			</div>
		</div>
	</div>
	<div *ngSwitchCase="NON_MODAL_ERROR_TYPE" class="text-center non-modal-error">
		<div *ngIf="!hideErrorIcon" class="flex justify-center">
			<svg fill="none" height="68" viewBox="0 0 68 68" width="68" xmlns="http://www.w3.org/2000/svg">
				<circle cx="34" cy="34" fill="#E94444" fill-opacity="0.1" r="34"/>
				<path
					d="M34 56.5C21.5736 56.5 11.5 46.4264 11.5 34C11.5 21.5736 21.5736 11.5 34 11.5C46.4264 11.5 56.5 21.5736 56.5 34C56.4864 46.4208 46.4208 56.4864 34 56.5ZM31.75 40.75V45.25H36.25V40.75H31.75ZM31.75 22.75V36.25H36.25V22.75H31.75Z"
					fill="#E94444"/>
			</svg>
		</div>
		<div class="m-t-16">
			<div class="success-title">
				{{title|titlecase}}
			</div>
		</div>
		<div class="m-t-6">
			<div class="success-des">
				{{description}}
			</div>
		</div>
		<div class="m-t-75">
			<div class="error-divider">
			</div>
		</div>
		<div *ngIf="!useFullButton" class="m-t-16">
			<div nz-row nzAlign="middle" nzJustify="center">
				<div (click)="cancelModal()" class="addCursor button-size-182 try-again">
					{{buttonText ? buttonText : 'Try Again'}}
				</div>
			</div>
		</div>
	</div>
</div>
